import { z } from "zod";

export const TENANT_DETAIL_TABS = [
  "users",
  "subscriptions",
  "packages",
  "grants",
  "traffic",
  "routing",
] as const;

export type TenantDetailTab = (typeof TENANT_DETAIL_TABS)[number];

/** Unknown or stale `?tab=` values fall back to the default tab instead of an empty body. */
export const tenantDetailSearch = z.object({
  tab: z.enum(TENANT_DETAIL_TABS).optional().catch(undefined),
  open: z.string().optional(),
});
